import React from 'react'
const Footer = () => {
    return (
        <div>
            {/* <div className="container py-3">
                &copy; 2021 Dental
            </div> */}
        </div>
    )
}
export default Footer;
